<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-22 10:33:26
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-16 11:27:07
 * @FilePath: /chaoyongtuan/src/views/shopManage/orderDetails/list/components/tableCell/activityCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="activity-cell">
		<div class="activity-head">
			<div class="activity-name font-h6-medium fz-12">{{ row.activity_name | formatEmpty }}</div>
		</div>
		<div class="activity-bottom font-h6-medium fz-12">活动ID：{{ row.activity_id | formatEmpty }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
	methods: {},
};
</script>
<style lang="less" scoped>
.activity-head {
	display: flex;
	align-items: center;
	.activity-name {
		color: @color-text-primary;
	}
}
.activity-bottom {
	color: #4e596a;
}
</style>
